import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthService } from '../../../core/http-services/auth.service';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  providers: [AppComponent]
})
export class NavbarComponent implements OnInit {
  isAuthenticated: boolean = false;
  userDisplayName: string = "";
  isShowSuccess: boolean = false;

  constructor(private authService: AuthService,
    private router: Router) { }

  //THIS IS DONE IN ORDER TO SOLVE IMAGE ERROR OF RELATIVE PATH WHEN PUBLISHED LIVE


  @Input() imgPath: string = "./assets/";
  imgFileName: string = "applogo.png";

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isLoggedIn();
    if (this.isAuthenticated)
      this.userDisplayName = this.authService.getUserDisplayName();
    else
      this.userDisplayName = "Unknown";
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

}
